module.exports = __webpack_public_path__ + "img/clement-glove2-min.5088e231.png";